import type { Product, Variant } from '@scayle/storefront-nuxt'

type AttributeValue = string | number | null | undefined

export const getAdvancedAttributeFirstValue = (
  object: Product | Variant | null,
  key: string
): AttributeValue => {
  return object?.advancedAttributes?.[key]?.values[0]?.fieldSet[0][0].value
}
